const ACCESS_TOKEN_KEY = 'predictions:access_token';
const USER_PROFILE_KEY = 'predictions:user_profile';

export interface TokenStore {
  getAccessToken(): string | null;
  setAccessToken(token: string): void;
  getUserProfile(): string | null;
  setUserProfile(profile: string): void;
  clear(): void;
}

class BrowserStorage implements TokenStore {
  private readonly storage: Storage;

  constructor(storage: Storage) {
    this.storage = storage;
  }

  getAccessToken(): string | null {
    return this.storage.getItem(ACCESS_TOKEN_KEY);
  }
  setAccessToken(token: string): void {
    this.storage.setItem(ACCESS_TOKEN_KEY, token);
  }
  getUserProfile(): string | null {
    return this.storage.getItem(USER_PROFILE_KEY);
  }
  setUserProfile(profile: string): void {
    this.storage.setItem(USER_PROFILE_KEY, profile);
  }
  clear(): void {
    this.storage.removeItem(ACCESS_TOKEN_KEY);
    this.storage.removeItem(USER_PROFILE_KEY);
  }
}

class MemoryStorage implements TokenStore {
  private accessToken: string | null = null;
  private userProfile: string | null = null;

  getAccessToken(): string | null {
    return this.accessToken;
  }
  setAccessToken(token: string): void {
    this.accessToken = token;
  }
  getUserProfile(): string | null {
    return this.userProfile;
  }
  setUserProfile(profile: string): void {
    this.userProfile = profile;
  }
  clear(): void {
    this.accessToken = null;
    this.userProfile = null;
  }
}

export function createTokenStore(type: 'localStorage' | 'sessionStorage' | 'memory' = 'localStorage'): TokenStore {
  if (type === 'memory' || typeof window === 'undefined') {
    return new MemoryStorage();
  }
  const storage = type === 'sessionStorage' ? window.sessionStorage : window.localStorage;
  return new BrowserStorage(storage);
}
